const KNOWN_LEVELS = new Set(['error', 'warning', 'info']);

// Lines without a level (e.g. plain text output) are not highlighted.
export function normalizeLevel(v) {
  if (!v) return null;

  const s = String(v).toLowerCase();

  if (s === 'warning') return 'warn';
  if (KNOWN_LEVELS.has(s)) return s;

  return 'error';
}

function mapLogEntry(x) {
  return {
    time_iso: x?.time_iso ? String(x.time_iso) : '',
    level: x?.level ?? null,
    raw:
      x?.raw != null ? String(x.raw) : x?.text != null ? String(x.text) : x?.message != null ? String(x.message) : null,
  };
}

export function parseLogRowsFromResponse(res) {
  if (!res) return [];

  const d = res?.data ?? res;

  if (Array.isArray(d)) return d.map(mapLogEntry);
  if (Array.isArray(d?.data)) return d.data.map(mapLogEntry);

  if (typeof d === 'string') {
    return d.split('\n').map((line) => ({ time_iso: '', level: null, raw: line }));
  }

  try {
    return [{ time_iso: '', level: null, raw: JSON.stringify(d, null, 2) }];
  } catch {
    return [{ time_iso: '', level: null, raw: String(d) }];
  }
}

export function formatRowText(r, level) {
  if (r.raw != null) return r.raw;

  const ts = r.time_iso ?? '';
  const lvl = level ?? normalizeLevel(r.level);

  const parts = [];
  if (ts) parts.push(ts);
  if (lvl) parts.push(lvl.toUpperCase());

  return parts.join('  ');
}

export function rowKey(r) {
  return `${r.time_iso}|${r.level}|${r.raw}`;
}

export function findOverlap(existing, incoming) {
  const a = existing.map(rowKey);
  const b = incoming.map(rowKey);

  const max = Math.min(a.length, b.length, 500);

  for (let k = max; k > 0; k--) {
    let ok = true;

    for (let i = 0; i < k; i++) {
      if (a[a.length - k + i] !== b[i]) {
        ok = false;
        break;
      }
    }

    if (ok) return k;
  }

  return 0;
}
